site.sticky = site.sticky || {};
site.sticky = $.extend(site.sticky, {
	box: function(target, stickyClass, offset, minWidth, maxWidth) {
		$(window).scroll(function() {
			site.sticky.scroll(target, stickyClass, offset, minWidth, maxWidth);
		});
		$(window).load(function() {
			site.sticky.scroll(target, stickyClass, offset, minWidth, maxWidth);
		});
	},

	scroll: function(target, stickyClass, offset, minWidth, maxWidth) {
		var $body = $('body'),
			$target = $(target),
			documentWidth = $(document).width() + 15;
		offset = offset || 0;
		minWidth = (minWidth !== undefined) ? minWidth : 768;
		maxWidth = (maxWidth !== undefined) ? maxWidth : documentWidth;

		if (documentWidth >= minWidth && documentWidth <= maxWidth) {
			var fromTop = $(window).scrollTop(),
				toTop = $target.offset().top - offset;

			/*
			if (target == 'body' && $body.hasClass('loggedIn')) {
				toTop+=31;
			}
			*/
			if (target !== 'body' && $body.hasClass('loggedIn')) {
				fromTop+=31;
			}

			if(fromTop >= toTop) {
				if (!$body.hasClass(stickyClass)) {
					if (typeof site.sticky.beforeStickyAdded === 'function') {
						site.sticky.beforeStickyAdded($target);
					}
					$body.addClass(stickyClass);
				}
			}
			else {
				if ($body.hasClass(stickyClass)) {
					if (typeof site.sticky.beforeStickyRemoved === 'function') {
						site.sticky.beforeStickyRemoved($target);
					}
					$body.removeClass(stickyClass);
				}
			}
		}
	}
});
